// Main app logic
import React, { useState } from "react";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import ExifParser from "exif-parser";

function App() {
  const [files, setFiles] = useState([]);
  const [organizedFiles, setOrganizedFiles] = useState(null);

  const handleDirectorySelection = async () => {
    try {
      const directoryHandle = await window.showDirectoryPicker();
      const filesArray = [];
      for await (const entry of directoryHandle.values()) {
        if (entry.kind === "file") {
          filesArray.push(entry);
        }
      }
      setFiles(filesArray);
      alert(`${filesArray.length} files loaded!`);
    } catch (err) {
      console.error("Error selecting directory:", err);
      alert("Directory access was denied.");
    }
  };

  const processFiles = async () => {
    const organized = {};
    for (const fileHandle of files) {
      const file = await fileHandle.getFile();
      const dateTaken = await extractDateFromExif(file);
      const category = determineCategory(dateTaken);

      if (!organized[category]) organized[category] = [];
      organized[category].push({ file, name: file.name });
    }
    setOrganizedFiles(organized);
  };

  const extractDateFromExif = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const parser = ExifParser.create(reader.result);
          const exifData = parser.parse();
          resolve(new Date(exifData.tags.DateTimeOriginal * 1000)); // EXIF DateTimeOriginal
        } catch {
          resolve(new Date(file.lastModified)); // Fallback: Last modified date
        }
      };
      reader.readAsArrayBuffer(file);
    });
  };

  const determineCategory = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`; // Example: "2024-12"
  };

  const downloadOrganizedFiles = async () => {
    const zip = new JSZip();

    for (const [category, files] of Object.entries(organizedFiles)) {
      const folder = zip.folder(category);
      for (const { file, name } of files) {
        folder.file(name, file);
      }
    }

    const zipContent = await zip.generateAsync({ type: "blob" });
    saveAs(zipContent, "organized_photos.zip");
  };

  return (
    <div className="App">
      <header>
        <h1>Local Photo Organizer</h1>
        <button onClick={handleDirectorySelection}>Select Directory</button>
        {files.length > 0 && <button onClick={processFiles}>Organize Photos</button>}
        {organizedFiles && (
          <div>
            <h3>Organized Files</h3>
            <ul>
              {Object.keys(organizedFiles).map((category) => (
                <li key={category}>
                  <strong>{category}</strong> ({organizedFiles[category].length} files)
                </li>
              ))}
            </ul>
            <button onClick={downloadOrganizedFiles}>Download Organized Files</button>
          </div>
        )}
      </header>
    </div>
  );
}

export default App;
